import { createCompassModalSwitcher } from "@/react/components/SettingsApp/CompassCompat/createCompassModalSwitcher";

import { PollVoteListModalComponent } from "./PollVoteListModalComponent";
import { PollVoteListModalUIKitComponent } from "./PollVoteListModalUIKitComponent";

export const usePollVoteListModal = createCompassModalSwitcher(
  PollVoteListModalComponent,
  PollVoteListModalUIKitComponent,
);
